module.exports = __webpack_public_path__ + "img/031.8ffb4c7f.png";